import { ReactNode, useState } from 'react';
import { uniqueId } from 'lodash';

import { TToast } from './types';

export type TAddPermanentToastArgs = {
    permanent?: never,
    id?: never,
} | {
    permanent: boolean,
    id: string,
};

export type TAddToastArgs = {
    children: ReactNode | JSX.Element,
} & TAddPermanentToastArgs;

export type TUseToaster = {
    getId: () => string,
    add: (children: ReactNode | JSX.Element, permanent?: boolean, id?: string) => void,
    remove: (id: string) => void,
    clear: () => void,
    toasts: Omit<TToast, 'direction'>[],
}

const useToaster = (): TUseToaster => {

    const [toasts, changeToasts] = useState<Omit<TToast, 'direction'>[]>([]);

    const getId = () => uniqueId();

    const add = (children: ReactNode | JSX.Element, permanent = false, id: string = uniqueId()): void => {
        changeToasts(prev => ([
            ...prev,
            { id, children, permanent },
        ]));
    };

    const remove = (id: string) => {
        changeToasts(prev => {
            const newStack = prev.filter(toast => toast.id !== id);
            return [...newStack];
        });
    };

    const clear = () => {
        changeToasts([]);
    };

    return {
        getId,
        add,
        remove,
        clear,
        toasts,
    };
};

export default useToaster;
